export const DEFAULT_VALUE: string = "Text";
export const BASE_FONT_SIZE: number = 14;
export const FONT_UNIT: string = "px";